<template>
  <main class="search-avia">
    <Header />
    <section class="template-header d-flex justify-center align-center text-center">
      <div class="shadow"></div>
      <div class="item">
        <h1
          class="font-weight-regular text-uppercase px-4"
        >{{ $vuetify.lang.t('$vuetify.serch-avia.template-header.title') }}</h1>
      </div>
    </section>
    <section class="template pt-6 pb">
      <v-container>
        <v-row>
          <v-col class="text-center">
            <h1>{{ $vuetify.lang.t('$vuetify.serch-avia.template.title') }}</h1>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current !== 'ru'}">
          <v-col>
            <iframe
              scrolling="no"
              width
              frameborder="0"
              src="//old.travelpayouts.com/widgets/d53d95dfa203a1af1b5178c86e0b55ce.html?v=1947"
            ></iframe>
          </v-col>
        </v-row>
        <v-row class="pt-6" :class="{hide: this.$vuetify.lang.current === 'ru'}">
          <v-col>
            <iframe
              scrolling="no"
              width
              frameborder="0"
              src="//old.travelpayouts.com/widgets/f9bd60ede8aa56db7c4a8dc3d73f36c6.html?v=1947"
            ></iframe>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Footer />
  </main>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
#app {
  .search-avia {
    height: 100%;
    .hide {
      display: none;
    }
    .template-header {
      background: url("../assets/background.jpg") center center / cover;
      .shadow {
        opacity: 1;
      }
    }
    .template {
      iframe {
        width: 100%;
        height: 140px;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    .search-avia {
      .template {
        iframe {
          width: 100%;
          height: 200px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  #app {
    .search-avia {
      .template {
        iframe {
          height: 270px;
        }
      }
    }
  }
}
@media screen and (max-width: 493px) {
  #app {
    .search-avia {
      .template {
        iframe {
          height: 400px;
        }
      }
    }
  }
}
</style>